import React, { ReactElement, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faAngleUp } from "@fortawesome/free-solid-svg-icons/faAngleUp";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons/faAngleDown";

import PlanFAQ from "../helpers/planFAQ"
// import styles from "../../styles/plans/Plans.module.scss"

import simplePlanStyles from "../../styles/plans/SimplifiedPlansOverview.module.scss"

import { faqTextForProductName } from "../../pages/Home";

import { 
    ProductCategory, 
} from "../../reducers/models"

function getFAQContent (state: Boolean, productCategory: ProductCategory): ReactElement {
    if (!state) {
        return <></>;
    }

    return (
        <PlanFAQ
            styles={simplePlanStyles}
            text={faqTextForProductName(productCategory)}
            showTitle={false}
        />
    );
}

export default function MultiFAQ (): ReactElement {

    const [openBB2State, setOpenBB2State] = useState(false);
    const [openBB3State, setOpenBB3State] = useState(false);
    const [openBB4State, setOpenBB4State] = useState(false);

    return (
        <div className = { simplePlanStyles.multiFAQ } >
            <div className = { simplePlanStyles.multiFAQtitle }>
                Frequently Asked Questions
            </div>
            <div className={simplePlanStyles.multiFAQContainer}>
                <div
                    className={simplePlanStyles.multiFAQHeader}
                    onClick={() => {
                        setOpenBB2State(!openBB2State);
                    }}
                >
                    <p>Buildbox Classic</p>
                    {<FontAwesomeIcon icon={openBB2State ? faAngleDown : faAngleUp} />}
                </div>
                {getFAQContent(openBB2State, ProductCategory.BB2)}
            </div>
            <div className={simplePlanStyles.multiFAQContainer}>
                <div
                    className={simplePlanStyles.multiFAQHeader}
                    onClick={() => {
                        setOpenBB3State(!openBB3State);
                    }}
                >
                    <p>Buildbox 3</p>
                    {<FontAwesomeIcon icon={openBB3State ? faAngleDown : faAngleUp} />}
                </div>
                {getFAQContent(openBB3State, ProductCategory.BB3)}
            </div>
            <div className={simplePlanStyles.multiFAQContainer}>
                <div
                    className={simplePlanStyles.multiFAQHeader}
                    onClick={() => {
                        setOpenBB4State(!openBB4State);
                    }}
                >
                    <p>Buildbox 4</p>
                    {<FontAwesomeIcon icon={openBB4State ? faAngleDown : faAngleUp} />}
                </div>
                {getFAQContent(openBB4State, ProductCategory.BB4)}
            </div>
        </div>
    );
}